
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const HeroSection = () => {
  return (
    <section className="relative h-screen min-h-[600px] flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/66bc635b7e5f031d648e39a3b378a95e.jpg"
          alt="Professional plumbing service"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 w-full">
        <div className="flex flex-col items-start justify-center min-h-[500px]">
          {/* Main Headline */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="mb-8"
          >
            <h1 className="text-5xl md:text-7xl lg:text-8xl font-bold text-white leading-tight mb-6">
              Fast, Reliable<br />Plumbing & Heating<br />in Otley
            </h1>
            <p className="text-white text-xl md:text-2xl font-light mb-2">
              Serving Wharfedale & surrounding villages
            </p>
            <p className="text-white text-xl md:text-2xl font-light">
              24/7 emergency callouts available
            </p>
          </motion.div>

          {/* CTAs */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.6 }}
            className="flex flex-col sm:flex-row gap-4"
          >
            <a
              href="tel:01943123456"
              className="flex items-center justify-between bg-[#1A2F4A] text-white px-8 py-4 rounded-full hover:bg-[#2A3F5A] transition-all shadow-lg group whitespace-nowrap cursor-pointer"
            >
              <span className="font-semibold text-lg">Call Now: 01943 123 456</span>
              <div className="w-10 h-10 flex items-center justify-center bg-white/20 rounded-full group-hover:bg-white/30 transition-colors ml-4">
                <i className="ri-phone-line text-xl"></i>
              </div>
            </a>

            <Link
              to="/contact"
              className="flex items-center justify-between bg-transparent text-white px-8 py-4 rounded-full border-2 border-white hover:bg-white hover:text-[#1A2F4A] transition-all shadow-lg group whitespace-nowrap cursor-pointer"
            >
              <span className="font-semibold text-lg">Request Free Quote</span>
              <i className="ri-arrow-right-line text-xl group-hover:translate-x-1 transition-transform ml-4"></i>
            </Link>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
